// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rail-container {
  position: relative;
}

.rail {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  position: relative;
  padding: 0;
  margin: 0;
}
.rail .rail-content {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  position: relative;
  padding: 0;
}
.rail li {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 40px;
  height: 40px;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -ms-flex-line-pack: center;
      align-content: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
.rail li img {
  -webkit-filter: invert(1) contrast(1.5) drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.7));
          filter: invert(1) contrast(1.5) drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.7));
  -webkit-transform: scale(2.1);
          transform: scale(2.1);
}
.rail li .rail-illustration {
  position: absolute;
  top: -30px;
  right: -30px;
  bottom: -30px;
  left: -30px;
}
.rail li canvas {
  -webkit-filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.7));
          filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.7));
  position: absolute;
  top: 0;
  left: 0;
}
.rail li.player-left, .rail li.player-right {
  position: absolute;
}
.rail li.player-right canvas {
  -webkit-transform: scale(-1, 1);
          transform: scale(-1, 1);
}
.rail .slot {
  border: 1px solid rgba(255, 255, 255, 0.1);
  -webkit-transition: background-color 0.2s;
  transition: background-color 0.2s;
}
.rail .slot.pointed {
  -webkit-transition: all 0.2s 0.3s;
  transition: all 0.2s 0.3s;
}
.rail .slot.slot-blue {
  background-color: rgb(56, 22, 209);
}
.rail .slot.slot-red {
  background-color: var(--red);
  -webkit-transition: background-color 0.2s 0.15s;
  transition: background-color 0.2s 0.15s;
}
.rail .slot.slot-red.pointed {
  -webkit-box-shadow: 0 0 10px 5px rgba(227, 137, 126, 0.52);
          box-shadow: 0 0 10px 5px rgba(227, 137, 126, 0.52);
  background: radial-gradient(#f6c8c8, #f5936c);
}
.rail .slot.slot-green {
  background-color: var(--green);
  -webkit-transition: background-color 0.2s 0.15s;
  transition: background-color 0.2s 0.15s;
}
.rail .slot.slot-green.pointed {
  -webkit-box-shadow: 0 0 10px 5px rgba(26, 135, 70, 0.5215686275);
          box-shadow: 0 0 10px 5px rgba(26, 135, 70, 0.5215686275);
  background: radial-gradient(#a3dfa3, #4cbf5d);
}
.rail .slot.slot-blue.slot-red {
  background: linear-gradient(135deg, rgb(56, 22, 209) 30%, rgb(212, 17, 17) 70%);
}
.rail .slot.slot-green.slot-red {
  background: linear-gradient(135deg, rgb(9, 104, 49) 30%, rgb(212, 17, 17) 70%);
}
@media screen and (max-width: 720px) {
  .rail .rail-content {
    margin-bottom: 15px;
  }
}

.rail-results {
  position: absolute;
  left: 0;
  right: 0;
}
.rail-results strong {
  -webkit-animation: 1s show both;
          animation: 1s show both;
}
.rail-results strong:nth-child(1) {
  -webkit-animation-delay: 0.25s;
          animation-delay: 0.25s;
}
.rail-results strong:nth-child(2) {
  -webkit-animation-delay: 0.5s;
          animation-delay: 0.5s;
}
.rail-results strong:nth-child(3) {
  -webkit-animation-delay: 0.75s;
          animation-delay: 0.75s;
}

@-webkit-keyframes show {
  0% {
    -webkit-transform: translate(0, 20px);
            transform: translate(0, 20px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translate(0, 0);
            transform: translate(0, 0);
    opacity: 0.6;
  }
}

@keyframes show {
  0% {
    -webkit-transform: translate(0, 20px);
            transform: translate(0, 20px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translate(0, 0);
            transform: translate(0, 0);
    opacity: 0.6;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/rail.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,2BAAA;EAAA,2BAAA;EAAA,oBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AACF;AACE;EACE,2BAAA;EAAA,2BAAA;EAAA,oBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,kBAAA;EACA,UAAA;AACJ;AAEE;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EAAA,oBAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;EACA,0BAAA;MAAA,qBAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;AAAJ;AAEI;EACE,mFAAA;UAAA,2EAAA;EAEA,6BAAA;UAAA,qBAAA;AADN;AAII;EACE,kBAAA;EACA,UAAA;EAAA,YAAA;EAAA,aAAA;EAAA,WAAA;AAFN;AAKI;EACE,2DAAA;UAAA,mDAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AAHN;AAMI;EAEE,kBAAA;AALN;AAQI;EACE,+BAAA;UAAA,uBAAA;AANN;AAUE;EACE,0CAAA;EACA,yCAAA;EAAA,iCAAA;AARJ;AAUI;EACE,iCAAA;EAAA,yBAAA;AARN;AAWI;EACE,kCAAA;AATN;AAYI;EACE,4BAAA;EACA,+CAAA;EAAA,uCAAA;AAVN;AAYM;EACE,0DAAA;UAAA,kDAAA;EACA,6CAAA;AAVR;AAcI;EACE,8BAAA;EACA,+CAAA;EAAA,uCAAA;AAZN;AAcM;EACE,gEAAA;UAAA,wDAAA;EACA,6CAAA;AAZR;AAgBI;EACE,+EAAA;AAdN;AAqBI;EACE,8EAAA;AAnBN;AA2BE;EACE;IACE,mBAAA;EAzBJ;AACF;;AA6BA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;AA1BF;AA4BE;EACE,+BAAA;UAAA,uBAAA;AA1BJ;AA6BE;EACE,8BAAA;UAAA,sBAAA;AA3BJ;AA8BE;EACE,6BAAA;UAAA,qBAAA;AA5BJ;AA+BE;EACE,8BAAA;UAAA,sBAAA;AA7BJ;;AAiCA;EACE;IACE,qCAAA;YAAA,6BAAA;IACA,UAAA;EA9BF;EAgCA;IACE,kCAAA;YAAA,0BAAA;IACA,YAAA;EA9BF;AACF;;AAsBA;EACE;IACE,qCAAA;YAAA,6BAAA;IACA,UAAA;EA9BF;EAgCA;IACE,kCAAA;YAAA,0BAAA;IACA,YAAA;EA9BF;AACF","sourcesContent":[".rail-container {\n  position: relative;\n}\n\n.rail {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  padding: 0;\n  margin: 0;\n\n  .rail-content {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    padding: 0;\n  }\n\n  li {\n    display: flex;\n    width: 40px;\n    height: 40px;\n    transition: all 0.5s;\n    flex-direction: column;\n    align-content: center;\n    justify-content: center;\n\n    img {\n      filter: invert(1) contrast(1.5)\n        drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.7));\n      transform: scale(2.1);\n    }\n\n    .rail-illustration {\n      position: absolute;\n      inset: -30px;\n    }\n\n    canvas {\n      filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.7));\n      position: absolute;\n      top: 0;\n      left: 0;\n    }\n\n    &.player-left,\n    &.player-right {\n      position: absolute;\n    }\n\n    &.player-right canvas {\n      transform: scale(-1, 1);\n    }\n  }\n\n  .slot {\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    transition: background-color 0.2s;\n\n    &.pointed {\n      transition: all 0.2s 0.3s;\n    }\n\n    &.slot-blue {\n      background-color: rgb(56, 22, 209);\n    }\n\n    &.slot-red {\n      background-color: var(--red);\n      transition: background-color 0.2s 0.15s;\n\n      &.pointed {\n        box-shadow: 0 0 10px 5px rgb(227 137 126 / 52%);\n        background: radial-gradient(#f6c8c8, #f5936c);\n      }\n    }\n\n    &.slot-green {\n      background-color: var(--green);\n      transition: background-color 0.2s 0.15s;\n\n      &.pointed {\n        box-shadow: 0 0 10px 5px #1a874685;\n        background: radial-gradient(#a3dfa3, #4cbf5d);\n      }\n    }\n\n    &.slot-blue.slot-red {\n      background: linear-gradient(\n        135deg,\n        rgb(56, 22, 209) 30%,\n        rgb(212, 17, 17) 70%\n      );\n    }\n\n    &.slot-green.slot-red {\n      background: linear-gradient(\n        135deg,\n        rgb(9, 104, 49) 30%,\n        rgb(212, 17, 17) 70%\n      );\n    }\n  }\n\n  @media screen and (max-width: 720px) {\n    .rail-content {\n      margin-bottom: 15px;\n    }\n  }\n}\n\n.rail-results {\n  position: absolute;\n  left: 0;\n  right: 0;\n\n  strong {\n    animation: 1s show both;\n  }\n\n  strong:nth-child(1) {\n    animation-delay: 0.25s;\n  }\n\n  strong:nth-child(2) {\n    animation-delay: 0.5s;\n  }\n\n  strong:nth-child(3) {\n    animation-delay: 0.75s;\n  }\n}\n\n@keyframes show {\n  0% {\n    transform: translate(0, 20px);\n    opacity: 0;\n  }\n  100% {\n    transform: translate(0, 0);\n    opacity: 0.6;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
